//导入封装好的新的axios
import request from '@/request/index'

//查询用户消息列表
export function getUserMessagesList(params) {
    return request({
        url: '/' + params.rgn + '/site/feedback/findUserFeedbackPage',
        method: 'get',
        params: {
            title: params.title,
            country: params.country,
            problemType: params.problemType,
            status: params.status,
            startTime: params.startTime,
            endTime: params.endTime,
            pageSize: params.pageSize,
            siteId: params.siteId,
            pageNum: params.pageNum,
            firstDataId: params.firstDataId,
        },
    })
}
//查询消息详情
export function getUserMessagesDetail(params) {
    return request({
        url: '/' + params.rgn + '/site/feedback/getUserFeedback',
        method: 'get',
        params: {
            userFeedbackId: params.userFeedbackId,
            siteId: params.siteId
        },
    })
}
//回复消息
export function replyUserMessages(params,data) {
    return request({
        url: '/' + params.rgn + '/site/feedback/replyUserFeedback',
        method: 'post',
        data
    })
}
//更新消息状态
export function updateUserMessages(params,data) {
    return request({
        url: '/' + params.rgn + '/site/feedback/updateUserFeedbackStatus',
        method: 'post',
        data
    })
}
export default { getUserMessagesList, getUserMessagesDetail, replyUserMessages, updateUserMessages }